<!-- BACKGROUND SLIDESHOW -->
<div class="auth-page hide-scrollbar">


  <div class="background-slideshow">
    <div *ngFor="let image of images; let i = index" class="background-slide"
      [style.background-image]="'url(' + image + ')'" [class.active]="i === activeIndex">
    </div>
  </div>

  <div class="auth-container">

    <!-- LEFT: FORM -->
    <div class="auth-left">

      <!-- Nebular Error Messages -->
      <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger">
        <p class="alert-title"><b>Login Failed</b></p>
        <ul>
          <li *ngFor="let error of errors">{{ error }}</li>
        </ul>
      </nb-alert>

      <!-- Nebular Success Messages -->
      <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success">
        <p class="alert-title"><b>Success</b></p>
        <ul>
          <li *ngFor="let message of messages">{{ message }}</li>
        </ul>
      </nb-alert>

      <div class="auth-header">
        <h2>Sign In to Your Account</h2>
        <p>Enter your credentials to access your account</p>
      </div>

      <form class="auth-form" (ngSubmit)="login()" #form="ngForm">

        <!-- EMAIL -->
        <!-- EMAIL -->
        <div class="form-group">
          <label class="form-label">Email Address</label>

          <div class="email-wrapper">
            <!-- USERNAME -->
            <input nbInput class="email-username" name="emailUsername" [(ngModel)]="emailUsername"
              #emailUsernameCtrl="ngModel" required placeholder="Enter your username"
              [status]="emailUsernameCtrl.invalid && emailUsernameCtrl.touched ? 'danger' : 'basic'">

            <!-- FIXED DOMAIN -->
            <input
      nbInput
      class="email-domain"
      [value]="domain"
      disabled>
            <!-- <input nbInput class="email-domain" disabled> -->
          </div>

          <p class="caption status-danger" *ngIf="emailUsernameCtrl.invalid && emailUsernameCtrl.touched">
            Username is required.
          </p>
        </div>


        <!-- PASSWORD -->
        <div class="form-group">
          <label class="form-label" for="password">Password</label>

          <div class="password-input">
            <input nbInput fullWidth [type]="showPassword ? 'text' : 'password'" id="password" name="password"
              class="form-input" [(ngModel)]="user.password" #password="ngModel" required minlength="4"
              placeholder="Enter your password" [status]="password.invalid && password.touched ? 'danger' : 'basic'">

            <button type="button" class="toggle-password" (click)="togglePassword()">
              <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>

          <p class="caption status-danger" *ngIf="password.invalid && password.touched">
            Password must be at least 4 characters.
          </p>
        </div>

        <!-- REMEMBER + FORGOT -->
        <div class="form-options">

          <!-- <div class="remember-me">
          <nb-checkbox [(ngModel)]="user?.rememberMe" name="rememberMe">
            Remember me
          </nb-checkbox>
        </div> -->

          <button type="button" class="forgotpass" (click)="router.navigate(['/auth/request-password'])">
            Forgot Password?
          </button>

        </div>

        <!-- SUBMIT BUTTON -->
        <button nbButton fullWidth status="primary" size="large" class="btn" [disabled]="submitted || !form.valid"
          [class.btn-pulse]="submitted">

          <span *ngIf="!submitted">Sign In</span>
          <span *ngIf="submitted">
            <i class="fas fa-spinner fa-spin"></i> Signing In...
          </span>

        </button>

        <!-- REGISTER LINK -->
        <div class="auth-footer">
          Don't have an account?
          <a class="register-link" (click)="router.navigate(['/auth/register'])">
            Create account
          </a>
        </div>

      </form>
    </div>

    <!-- RIGHT SIDE -->
    <div class="auth-right">
      <div class="auth-right-inner">

        <!-- Logo -->
        <div class="logo">
          <img src="assets/images/logoDS.png" alt="Portus ERP">
        </div>

        <!-- Corporate Headline -->
        <!-- <div class="auth-message">

      <p class="tagline">
        Enterprise Platform for Freight & Logistics Operations
      </p>
    </div> -->

        <!-- Value points -->
        <!-- <ul class="auth-points">
      <li>Unified Freight, Accounts & Operations</li>
      <li>Role-based Access & Approval Flow</li>
      <li>Real-time Reporting & Job P&L</li>
      <li>Secure Cloud Infrastructure</li>
    </ul> -->

        <!-- Footer note -->
        <div class="auth-footer-note">
          © 2025 Portus · All rights reserved
        </div>




      </div>
    </div>

    <!-- <button class="theme-toggle" (click)="toggleTheme()">
    <i [class]="isDark ? 'fas fa-sun' : 'fas fa-moon'"></i>
  </button> -->
  </div>
</div>
